import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IConfiguration } from "../../services/data-file-import-data-service/Models";
import DataFileImportDataService from "../../services/data-file-import-data-service/DataFileImportDataService";

export type UseDataFileImportConfigurationParams = {
    groupID: number,
    configurationID: number
} & BaseUseQueryParameters<IConfiguration | undefined>;

export function useDataFileImportConfiguration({
    groupID,
    configurationID,
    enabled,    
    onSuccess,
    onError
}: UseDataFileImportConfigurationParams) {
    return useQuery<IConfiguration, RestError>(
        keys.configuration(groupID, configurationID),
        ({ signal }) => {
            return DataFileImportDataService.getConfiguration(
                groupID,
                configurationID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            // refetchInterval: false,
            // staleTime: Infinity,
            // refetchOnWindowFocus: false,
            // refetchOnMount: true,
            // refetchOnReconnect: false,
            // retry: false,
        }
    );
}